module.exports = __webpack_public_path__ + "static/img/8.13d6206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/8.png
// module id = bJi7
// module chunks = 10